import devWarning, { resetWarned } from "rc-util/es/warning";
export { resetWarned };
export default (function (valid, component, message) {
  devWarning(valid, "[antd: ".concat(component, "] ").concat(message));
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/devWarning.js
// module id = 18
// module chunks = 0